import { Message, MessageBox } from "element-ui";
import { getErrorMessage } from "./utils";

export default {
  install(Vue, { i18n }) {
    Vue.prototype.$errorMessage = function (error) {
      const errorCodeMessageKey = "ERROR_CODE_MESSAGE.";
      return typeof error === "string"
        ? error
        : getErrorMessage(error, (key) =>
            i18n
              .t(`${errorCodeMessageKey}${key}`)
              .replace(errorCodeMessageKey, "")
          );
    };

    Vue.prototype.$error = function (error) {
      const message = Vue.prototype.$errorMessage(error);
      Message.error(message);
    };
    Vue.prototype.$showLoading = function () {
      Vue.prototype.$loading();
    };
    Vue.prototype.$hideLoading = function () {
      Vue.prototype.$loading().close();
    };
    Vue.prototype.$showConfirm = function ({
      title = "提示",
      message,
      confirmButtonText = "確定",
      cancelButtonText = "取消",
      type = "warning",
    }) {
      return MessageBox.confirm(message, title, {
        confirmButtonText,
        cancelButtonText,
        type,
      });
    };
  },
};
